// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__AjXg0","title":"HeroContent_title__Nzi4G","description":"HeroContent_description__jO202","control":"HeroContent_control__+V+lK"};